/* eslint-disable prettier/prettier */
import { Badge, Button } from 'reactstrap';
import { TileClaimsProps } from '../../claims/new/typings';
import React from 'react';
import _ from 'lodash';
import history from '../../../helpers/history';

const IncomingClaims: React.FC<TileClaimsProps> = ({ claims, partner }) => {
  const unclaimed = _.reduce(
    _.map(claims, (c) => (c?.status ==='NEW' && !_.isString(c?.assign.partners) ? 1 : 0)),
    (sum, n) => sum + n,
    0,
  );
  const isDisabled = _.size(claims) <= 0;
  return (
    <Button className="claim-tile" disabled={isDisabled} onClick={() => history.push('/incoming')}>
      {unclaimed > 0 ? (
        <Badge color="danger" className="claim-tile-badge">
          <span>{unclaimed}</span>
          <strong>Unassigned:</strong>
        </Badge>
      ) : (
        false
      )}
      <div className="counter">{_.size(claims)}</div>
      <div className="title">Received Jobs</div>
      <div className="subtitle">Assigned to {partner.name}</div>
    </Button>
  );
};

export default IncomingClaims;
